import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { getCurrencySymbol } from '../../common_components/choices';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ProductSavingsChart = () => {
    const [savingsData, setSavingsData] = useState([]);

    const fetchSavingsData = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/highgarden/product-savings/`, {
                headers: { Authorization: `Token ${token}` }
            });
            setSavingsData(response.data);
        } catch (error) {
            console.error('Error fetching product savings data:', error);
        }
    };

    useEffect(() => {
        fetchSavingsData();
    }, []);

    const processChartData = () => {
        const labels = savingsData.map(item => item.month);
        const datasets = [];

        savingsData.forEach((item, index) => {
            const currencySymbol = getCurrencySymbol(item.currency);

            Object.keys(item.products).forEach(productId => {
                const productData = item.products[productId][0];
                const dataset = datasets.find(ds => ds.label === productData.product_name);

                if (dataset) {
                    dataset.data[index] = productData.savings;
                } else {
                    datasets.push({
                        label: productData.product_name,
                        data: Array(savingsData.length).fill(0),
                        backgroundColor: `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.5)`,
                        borderColor: `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 1)`,
                        borderWidth: 1,
                        stack: 'Stack 0',
                        currencySymbol: currencySymbol, // Store currency symbol for tooltip
                    });
                    datasets[datasets.length - 1].data[index] = productData.savings;
                }
            });
        });

        return { labels, datasets, currencySymbol: savingsData.length ? getCurrencySymbol(savingsData[0].currency) : '' };
    };

    const chartData = processChartData();

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                display: false,
            },
            title: {
                display: true,
                text: 'Product Savings by Month',
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const dataset = context.dataset;
                        const index = context.dataIndex;
                        const savings = dataset.data[index];
                        const currencySymbol = dataset.currencySymbol;
                        return `${dataset.label}: ${currencySymbol} ${savings.toFixed(2)}`;
                    },
                    footer: (tooltipItems) => {
                        const totalSavings = savingsData[tooltipItems[0].dataIndex].total_savings;
                        const currencySymbol = chartData.currencySymbol;
                        return `Total Savings: ${currencySymbol} ${totalSavings.toFixed(2)}`;
                    }
                }
            }
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
                beginAtZero: true,
            }
        }
    };

    return (
        <div>
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default ProductSavingsChart;
